<template>
  <div>
    <!-- <custom-filter
      :fields="filterFields"
      @onFilter="onFilter"
      @onClear="onClearFilter"
    /> -->
    <b-card title="Assinaturas">
      <b-button
      class="btn-sm btn-nav-link btn-nav-link-white"
      size="sm"
      variant="flat-primary"
      @click="reportData"
    >
    
      <feather-icon icon="FileTextIcon" />
      Exportar
    </b-button>
      <custom-g-table
        :displayLoading="tableLoading"
        :fields="fields"
        :items="data"
        :limit="limit"
        :totalRows="totalRows"
        @changePage="onChangePage"
        @onSortChange="onSortChange"
        @onColumnFilter="onFilter"
      />
    </b-card>
  </div>
</template>

<script>
import { BCard, BButton } from "bootstrap-vue";
import CustomGTable from "@/views/custom/table/CustomGTable.vue";
import subscriberService from "@/providers/subscriberService";
// import CustomFilter from "@/views/custom/table/CustomFilter.vue";
import AppConstants from "@/appConstants";
import dropdownService from "@/providers/dropdownService";
import { onlyLatestRequest } from "@/helpers/latest-request-helper";

export default {
  components: {
    BCard,
    BButton,
    CustomGTable,
    // CustomFilter,
  },
  data() {
    return {
      sortField: {},
      limit: AppConstants.PAGINATOR_DEFAULT_LIMIT,
      totalRows: 0,
      page: 1,
      filterFields: [
        {
          id: "filter-email",
          placeholder: "Email",
          type: "text",
          inputType: "text",
          model: "email",
        },
        {
          id: "filter-origin",
          placeholder: "Origem",
          type: "list",
          inputType: "",
          model: "origin",
          list: "filter-list-origin",
          array: [],
        },
      ],
      filter: {},
      tableLoading: true,
      fields: [
        { field: "email", label: "Email", sortable: true, filterOptions: { enabled: true, placeholder: 'Pesquisar por email', trigger: 'enter' } },
        { field: "name", label: "Nome", sortable: true, filterOptions: { enabled: true, placeholder: 'Pesquisar por nome', trigger: 'enter' } },
        { field: "phone", label: "Telefone", sortable: false },
        { field: "subject", label: "Assunto", sortable: false },
        { field: "comment", label: "Comentário", sortable: false },
        { field: "origin", label: "Origem", type: "object", sortable: false, filterOptions: { enabled: true, placeholder: 'Pesquisar por origem', filterDropdownItems: [] } },
        { field: "dt_create", label: "Criação", type: "custom_date", sortable: true },
      ],
      /* eslint-disable global-require */
      data: [],
      origins: [],
    };
  },
  mounted() {
    this.$store.dispatch("admin/updatePageTitle", 'Assinaturas');
    this.loadDataFilter();
    this.loadData();
  },
  computed: {
    searchParams() {
      const params = new URLSearchParams();
      params.append("page", this.page);
      params.append("limit", this.limit);

      if (this.filter.email) {
        params.append("email", this.filter.email);
      }
      if (this.filter.name) {
        params.append("name", this.filter.name);
      }
      if (this.filter.origin) {
        params.append("origin", this.filter.origin);
      }
      if (this.filter.dt_create) {
        params.append("dt_create", this.filter.dt_create);
      }
      if (this.filter.active) {
        params.append("active", this.filter.active);
      }
      if (this.sortField.field) {
        params.append(`sort_${this.sortField.field}`, this.sortField.type);
      }
      return params;
    },
  },
  methods: {
    reportData() {
      const params = this.searchParams;
      params.append("download", true);
      subscriberService
        .report(params)
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");

          link.href = url;
          link.setAttribute("download", "assinaturas.xlsx");
          link.setAttribute("id", "link-download");

          document.body.appendChild(link);
          link.click();

          document.getElementById("link-download").remove();
        })
        .catch((err) => console.log(err));
    },
    onChangePage(page) {
      this.page = page;
      this.loadData();
    },
    onFilter(data) {
      this.filter = data;
      // console.log('OnFilter: ', this.filter);
      this.loadData();
    },
    onClearFilter() {
      this.filter = {};
      this.loadData();
    },
    loadDataFilter() {
      dropdownService
        .getAllOrigin(new URLSearchParams())
        .then((res) => {
          const origins = res.map(item => {
            return { value: item.id, text: item.name };
          });
          this.fields[this.fields.findIndex(item => item.field=='origin')].filterOptions.filterDropdownItems = origins;
        })
        .catch((err) => console.log(err));
    },
    loadData() {
      this.tableLoading = true;
      onlyLatestRequest(this, 'loadData', subscriberService.getAllSubscribe(this.searchParams))
        .then((res) => {
          this.tableLoading = false;
          // console.log(res);
          this.data = res.data;
          this.totalRows = res.totalRows;
        })
        .catch((err) => console.log(err));
    },
    onSortChange(params) {
      this.sortField = params;
      this.loadData();
    },
  },
};
</script>

<style>
</style>